import React, { useEffect, useRef, useState } from "react";
import { useAddAssignmentMutation } from "../../features/assignments/assignemntsApi";
import { useGetVideosQuery } from "../../features/videos/videosApi";
import Success from "../ui/Success";
import styles from "./assignmentForm.module.css";

export default function AssignmentAddForm() {
  const titleRef = useRef();
  const chooseVideoRef = useRef();
  const totalMarkRef = useRef();
  const [isAssignmentAdded, setIsAssignmentAdded] = useState(false);

  const { data: videos } = useGetVideosQuery();
  const [addAssignment, { isSuccess: isAddAssignmentSuccess }] =
    useAddAssignmentMutation();

  const clearForm = () => {
    titleRef.current.value = "";
    chooseVideoRef.current.value = 1;
    totalMarkRef.current.value = null;
  };

  const handleEdit = (e) => {
    e.preventDefault();
    const videoTitle = videos?.find(
      (video) => video.id === Number(chooseVideoRef.current.value)
    ).title;
    const data = {
      title: titleRef?.current.value,
      video_id: chooseVideoRef.current.value,
      video_title: videoTitle,
      totalMark: Number(totalMarkRef.current.value),
    };

    addAssignment(data);
  };
  useEffect(() => {
    if (isAddAssignmentSuccess) {
      clearForm();
      setIsAssignmentAdded(true);
    }
  }, [isAddAssignmentSuccess, setIsAssignmentAdded]);

  return (
    <>
      <div className="justify-center mb-10 space-y-2 flex md:space-y-0">
        <form
          onSubmit={handleEdit}
          className={`${styles.videoForm}  bg-primary border border-slate-50/10 `}
        >
          <div className="formGroup flex items-center justify-between">
            <label htmlFor="titleInput">Title</label>
            <input
              onChange={() => setIsAssignmentAdded(false)}
              required
              className="bg-slate-900 p-2 "
              type="text"
              id="titleInput"
              ref={titleRef}
            />
          </div>
          <div className="formGroup flex items-center justify-between">
            <label htmlFor="chooseVideoSelect">Choose video</label>
            <select
              onChange={() => setIsAssignmentAdded(false)}
              ref={chooseVideoRef}
              id="chooseVideoSelect"
              className="bg-slate-900 p-2 "
              defaultValue={1}
            >
              {videos?.map((video) => (
                <option value={video.id} key={video.id}>
                  {video.title}
                </option>
              ))}
            </select>
          </div>

          <div className="formGroup flex items-center justify-between">
            <label htmlFor="TotalMarkInput">Total Mark</label>
            <input
              onChange={() => setIsAssignmentAdded(false)}
              required
              className="bg-slate-900 p-2 "
              type="number"
              id="TotalMarkInput"
              ref={totalMarkRef}
            />
          </div>
          {isAssignmentAdded && (
            <Success message={"Assignment added successfully"} />
          )}

          <button
            type="submit"
            className="block ml-auto bg-violet-600 p-2 px-4 rounded-md text-white"
          >
            Add
          </button>
        </form>
      </div>
    </>
  );
}
